import React, {useEffect, useState} from "react";
import "./CustomerCare.scss";
import type {TabsProps} from "antd";
import {HistoryExamine, Tabs} from "components/common";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {setButtonsHeader, setSiderKey} from "redux/reducer/common";
import {tabKeys} from "types/enums";
import CustomerList from "./components/CustomerList/CustomerList";
import Chart from "./components/Chart/Chart";
import CSKHManagement from "./components/CSKHManagement/CSKHManagement";

const itemsInit: TabsProps["items"] = [
  {
    key: tabKeys.CUSTOMER_CARE.CARE,
    label: `Danh sách khách hàng`,
    children: <CustomerList />,
  },
  // {
  //   key: tabKeys.CUSTOMER_CARE.CARE_DETAIL,
  //   label: `Chi tiết thông tin`,
  //   children: <DetailPatient />,
  // },
  {
    key: tabKeys.CUSTOMER_CARE.HISTORY_CSKH,
    label: `Lịch sử khám bệnh`,
    children: <HistoryExamine />,
  },
  // {
  //   key: tabKeys.CUSTOMER_CARE.ADVANCE_REPORT,
  //   label: `Báo cáo nâng cao`,
  //   children: <Chart />,
  // },
  {
    key: tabKeys.CUSTOMER_CARE.CSKH_MANAGEMENT,
    label: `Quản lý danh mục CSKH`,
    children: <CSKHManagement />,
  },
];

const CustomerCare = () => {
  document.title = "Chăm sóc khách hàng";
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(setButtonsHeader([]));
    dispatch(setSiderKey("cskh"));
  }, []);
  const activeTab = useAppSelector(state => state.common.activeTab);
  const [items, setItems] = useState<TabsProps["items"]>(itemsInit);
  const idCustomerCare = useAppSelector(e => e.customerCare.idCustomerCare);

  useEffect(() => {
    itemsInit[1].disabled = idCustomerCare == null;
    setItems([...itemsInit]);
  }, [idCustomerCare]);
  return (
    <div className="customer-care page">
      <div className="main">
        <Tabs activeKey={activeTab} items={items} />
      </div>
    </div>
  );
};

export default CustomerCare;
